export default { 
  h5c01e16ad4e666a81b80c19ef44746b8: [[({
  notifications: notifications
}, []) => [notifications.widgets.length], {}]],
  hebe5812c7ee92643ba6dbb89bb5ba9d5: [[({
  notifications: notifications
}, []) => [notifications.widgets.length], {}]] 
}